import { gql } from '@apollo/client';
import { maritimeDirectoryPortModel } from 'model';

export interface GetMaritimeDirectoryPortResponse {
  maritimeDirectoryPorts?: Partial<maritimeDirectoryPortModel>[];
}

export const GET_MARITIME_DIRECTORY_PORTS = gql`
  query getMaritimeDirectoryPorts($where: MaritimeDirectoryPortFilterInput, $order: [MaritimeDirectoryPortSortInput!]) {
    maritimeDirectoryPorts(where: $where, order: $order) {
      id
      maritimeDirectoryId
      portId
      port {
        id
        name
        country
      }
      isActive
    }
  }
`;
